import {FC} from "react";
import {BaseIcon, IPropsIcon} from "./BaseIcon";

interface IProps extends IPropsIcon {

}

export const WatchIcon: FC<IProps> = ({size = 15, fill = 'none'}) => {
    return (
        <BaseIcon size={size} viewBox="0 0 11 15" fill={fill}>
            <path
                d="M9.25 3.83984V1.40625C9.25 1.05078 8.94922 0.75 8.59375 0.75L2.90625 0.75C2.52344 0.75 2.25 1.05078 2.25 1.40625L2.25 3.83984C1.15625 4.82422 0.5 6.21875 0.5 7.75C0.5 9.30859 1.15625 10.7031 2.25 11.6875V14.0938C2.25 14.4766 2.52344 14.75 2.90625 14.75L8.59375 14.75C8.94922 14.75 9.25 14.4766 9.25 14.0937V11.6875C10.3164 10.7031 11 9.30859 11 7.75C11 6.21875 10.3164 4.82422 9.25 3.83984ZM3.125 1.625L8.375 1.625V3.21094C7.58203 2.77344 6.70703 2.5 5.75 2.5C4.79297 2.5 3.89063 2.77344 3.125 3.21094L3.125 1.625ZM8.375 13.875L3.125 13.875L3.125 12.3164C3.89063 12.7539 4.79297 13 5.75 13C6.70703 13 7.58203 12.7539 8.375 12.3164V13.875ZM5.75 12.125C3.31641 12.125 1.375 10.1836 1.375 7.75C1.375 5.34375 3.31641 3.375 5.75 3.375C8.15625 3.375 10.125 5.34375 10.125 7.75C10.125 10.1836 8.15625 12.125 5.75 12.125ZM7.08984 9.60937C7.22656 9.71875 7.41797 9.69141 7.52734 9.55469L7.66406 9.36328C7.77344 9.22656 7.74609 9.00781 7.58203 8.89844L6.1875 7.88672V4.87891C6.1875 4.6875 6.02344 4.55078 5.85938 4.55078H5.64063C5.44922 4.55078 5.3125 4.6875 5.3125 4.87891V8.16016C5.3125 8.26953 5.33984 8.35156 5.42188 8.43359L7.08984 9.60937Z"
                fill="#7D8286"
            />
        </BaseIcon>
    )
}
